import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllCustomersQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  nameIncludes?: Types.InputMaybe<Types.Scalars['String']>;
  oldNumber?: Types.InputMaybe<Types.Scalars['Float']>;
  customerType?: Types.InputMaybe<Types.Scalars['String']>;
  text?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AllCustomersQuery = { __typename?: 'Query', allCustomers?: { __typename?: 'CustomerNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CustomerNodeEdge', cursor: string, node?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, title?: Types.CustomersCustomerTitleChoices | null, isActive: boolean } | null } | null> } | null };


export const AllCustomersDocument = gql`
    query AllCustomers($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $nameIncludes: String, $oldNumber: Float, $customerType: String, $text: String) {
  allCustomers(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    nameIncludes: $nameIncludes
    oldNumber: $oldNumber
    customerType: $customerType
    text: $text
    isActive: true
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        email
        name
        title
        isActive
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAllCustomersQuery__
 *
 * To run a query within a React component, call `useAllCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCustomersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      nameIncludes: // value for 'nameIncludes'
 *      oldNumber: // value for 'oldNumber'
 *      customerType: // value for 'customerType'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAllCustomersQuery(baseOptions?: Apollo.QueryHookOptions<AllCustomersQuery, AllCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCustomersQuery, AllCustomersQueryVariables>(AllCustomersDocument, options);
      }
export function useAllCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCustomersQuery, AllCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCustomersQuery, AllCustomersQueryVariables>(AllCustomersDocument, options);
        }
export type AllCustomersQueryHookResult = ReturnType<typeof useAllCustomersQuery>;
export type AllCustomersLazyQueryHookResult = ReturnType<typeof useAllCustomersLazyQuery>;
export type AllCustomersQueryResult = Apollo.QueryResult<AllCustomersQuery, AllCustomersQueryVariables>;